
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  components: { VueSlickCarousel },
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // mobile
      mobilePinIdSelected: 0,
      scaledId: 1,
      mobileSpaces: [],

      // author: {
      //   label: '',
      //   link: '',
      // },
      // location: {
      //   label: '',
      //   link: '',
      // },
      showModal: false,
      currentSlide: 0,
      settings: {
        centerMode: true,
        centerPadding: '5px',
        focusOnSelect: true,
        infinite: false,
        slidesToScroll: 1,
        variableWidth: true,
        speed: 500,
        initialSlide: 0,
        dots: false,
        arrows: false,
      },
    }
  },
  watch: {
    showModal: {
      handler(newVal) {
        if (newVal) {
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = 'scroll'
        }
      },
    },
  },

  methods: {
    scale(id) {
      this.scaledId = id
    },
    next() {
      this.$refs.carousel.next()
    },
    prev() {
      this.$refs.carousel.prev()
    },
    onChange(_, newVal) {
      // const { author, author_link, location, location_link } =
      //   this.blok.well_spaces[newVal]

      this.currentSlide = newVal
      // this.author.label = author
      // this.author.link = author_link.url
      // this.location.label = location
      // this.location.link = location_link.url
    },
    open(id, i) {
      // const { author, author_link, location, location_link } = showcase

      // set data and open modal
      this.settings.initialSlide = i
      this.currentSlide = i
      // this.author.label = author
      // this.author.link = author_link.url
      // this.location.label = location
      // this.location.link = location_link.url

      // setr mobile arr for responsive
      const cloneArr = [...this.blok.well_spaces]
      const sortArr = [
        cloneArr.find((blok) => blok._uid === id),
        ...cloneArr.filter((blok) => blok._uid !== id),
      ]

      this.mobileSpaces = sortArr
      this.showModal = true
    },
    // openMobile(id, i) {
    //   const cloneArr = [...this.blok.well_spaces]
    //   const sortArr = [
    //     cloneArr.find((blok) => blok._uid === id),
    //     ...cloneArr.filter((blok) => blok._uid !== id),
    //   ]

    //   this.mobileSpaces = sortArr
    //   this.open(i)
    // },
    closeModal() {
      this.showModal = false
    },
  },
}
